import styled from 'styled-components';
import { colors } from '../../constants';

interface IProps {
    topChoice?: boolean;
}

export const Sticker = styled.div<IProps>`
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: ${({ topChoice }) =>
        topChoice ? colors.topChoice : colors.yellow};
    color: ${({ topChoice }) => (topChoice ? colors.white : colors.greenDark)};
    padding: 8px;
    font-size: 15px;
`;
